import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Disclaimer.css";
import parse from "html-react-parser"

const Disclaimer = ({data})=>{
    const {disclaimer1} = data?.disclaimer
    return(
        <div className='disclaimer-bg'>
            <Container>
                <Row>
                    <Col>
                    <p className="disclaimertext">{parse(disclaimer1)}</p>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Disclaimer;